import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Translation from "../../../utils/Translation";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import { getValByLang } from "../../../utils/helpers";
import { useDispatch } from "react-redux";
import {
  setProducts,
  updateProductQuantityAsync,
} from "../../../services/store/storeSlice";
import { useState } from "react";
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

export default function UpdateQuantityModal({ openQty, setOpenQty, product }) {
  const { colors, sizes, attributesLoaded, custom_attributes, products,errorStore } =
    useSelector((state) => state.store);
  const { language } = useSelector((state) => state.global);
  const { data } = useSelector((state) => state.address);
  const auth = useSelector((state) => state.auth);
  const dynamicState = useSelector((state) => state.dynamicConfig);
  const dispatch = useDispatch();
  const [detailsId, setDetailsId] = useState(null);
  const [qty, setQty] = useState(1);
  const [submit, setSubmit] = useState(true);
  const [msg,setMsg] = useState()
  const handleChangeDetails = (event) => {
    setSubmit(true);
    setDetailsId(event.target.value);
    event.target.value && qty && qty > 0 && setSubmit(false);
  };

  const handleChangeQty = (event) => {
    setSubmit(true);
    setQty(event.target.value);
    event.target.value && event.target.value > 0 && detailsId && setSubmit(false);
  };

  const handleClose = () => {
    setOpenQty(false);
    setSubmit(false);
    setMsg('');
  };

  const handleCustomAttr = (val,idx) => {
    return custom_attributes.filter(
      (attr) => attr.id === val.custom_attribute_keys[idx]
    )[0];
  };

  const handleQuantity = async () => {

    let data = {
      id: Number(detailsId),
      quantity: Number(qty),
    };
    setSubmit(true);
    setMsg('');
    const action = await dispatch(
      updateProductQuantityAsync({ auth, dynamicState, data })
    );
    if (updateProductQuantityAsync.fulfilled.match(action)) {
      console.log("Success:", action.payload);

      let newProduct = products.filter((pro) => pro.id === product.id)[0];
      let updateDetails = newProduct.details.map((item) =>
        item.id === detailsId
          ? { ...item, count: Number(item.count) + Number(qty) }
          : item
      );
      const lastResult = {
        ...newProduct , details: updateDetails
      }
      dispatch(
        setProducts(
          products.map((item) =>
            item.id === lastResult.id ? lastResult : item
          )));
      
      setSubmit(false);
      setMsg(<Translation data="request.msg_added"  />);
    } else if (updateProductQuantityAsync.rejected.match(action)) {
      console.error("Error:", errorStore);
      setSubmit(false);
      setMsg(errorStore);
    }
  };

  return (
    <div>
      <Modal
        open={openQty}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="modal-qty"
      >
        <Box sx={{ ...style, width: 600 }}>
          <h2 id="parent-modal-title">
            <Translation data="store_seller.add_quantity_title" />{" "}
          </h2>

          {msg && 
           <FormControl className="limit mb-2" fullWidth>
              <Alert icon={!errorStore && <CheckIcon fontSize="inherit" />} severity={errorStore? "error" :"success" }>
                {msg}
              </Alert>
            </FormControl>
          }

          {product.details?.length > 0 &&  attributesLoaded &&
            <FormControl className="limit" fullWidth>
              <InputLabel id="demo-simple-select-label">
                {" "}
                <Translation data="order_seller.details" />{" "}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="sort_product_input"
                value={detailsId}
                label="Sort"
                onChange={handleChangeDetails}
              >
                {
                  product.details.map((val, idx) => (
                    <MenuItem key={idx} className="sort_product" value={val.id}>
                      {[
                        val.storage_id
                          ? data.find((attr) => attr.fav_id === val.storage_id)
                              ?.address_data?.friendly_name
                          : "",
                        val.color_id
                          ? getValByLang(
                              colors.find((attr) => attr.id === val.color_id)
                                ?.name,
                              language
                            )
                          : "",
                        val.size_id
                          ? getValByLang(
                              sizes.find((attr) => attr.id === val.size_id)?.name,
                              language
                            )
                          : "",
                        val.custom_attribute_keys?.length > 0 &&
                        val.custom_attribute_values?.length > 0
                          ?val.custom_attribute_keys.map((custom_attributes,idx) => (
                            (getValByLang(handleCustomAttr(val,idx)?.name, language) +
                            " : " +
                            getValByLang(
                              handleCustomAttr(val,idx)?.values.filter((attr) =>
                                val.custom_attribute_values.includes(
                                  attr.value_id
                                )
                              )[0]?.value,
                              language
                            ))
                          ))   
                          : "",
                      ]
                        .filter(Boolean)
                        .join(" - ")}
                    </MenuItem>
                  ))
                }
                
              </Select>
            </FormControl>
          }
          <FormControl sx={{ mt: 2 }}>
            <TextField
              onChange={handleChangeQty}
              value={qty ? qty : ""}
              id="outlined-basic"
              label=<Translation data="order_seller.quantity" />
              variant="outlined"
              type="number"
            />

            <Stack direction="row" spacing={2} className="mt-2 qty-button-gap">
              <Button
                variant="contained"
                onClick={() => handleQuantity()}
                size="large"
                className="font-weight-600"
                type="submit"
                disabled={submit}
              >
                {<Translation data="address.save" />}
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={() => handleClose()}
              >
                {<Translation data="address.cancel" />}
              </Button>
            </Stack>
          </FormControl>
        </Box>
      </Modal>
    </div>
  );
}
